import { Box, Button, Heading, TextButton } from '@wix/design-system'
import React, { FC, useCallback, useEffect, useMemo } from 'react'

import { useFlowLogger } from '../../../bi/mfi'
import { HeadlessBackground } from '../../reusable/HeadlessBackground'
import { dataHooks } from './HeadlessFallback.dataHooks'
import s from './HeadlessFallback.scss'
import Image from './Image.svg'

interface HeadlessFallbackProps {
  dataHook?: string
}

const HEADLESS_SITE_CREATION_URL = 'https://manage.wix.com/edit-template/to-headless'

export const HeadlessFallback: FC<HeadlessFallbackProps> = ({ dataHook }) => {
  const flowLogger = useFlowLogger()
  const pageLogger = useMemo(
    () => flowLogger.createPageLogger({ pageBiSlug: 'headless-fallback;something_went_wrong’' }),
    [flowLogger],
  )
  const handleRefreshButtonClick = useCallback(async () => {
    await pageLogger.answer({ answer: 'refresh' })
    window.location.reload()
  }, [pageLogger])

  const handleGoToDashboardButtonClick = useCallback(async () => {
    await pageLogger.answer({ answer: 'dashboard' })
    window.location.href = HEADLESS_SITE_CREATION_URL
  }, [pageLogger])

  useEffect(() => {
    void pageLogger.screenView()
  })

  return (
    <HeadlessBackground dataHook={dataHook}>
      <Box direction="vertical" margin="auto" align="center">
        <Image />
        <Box gap="SP2" textAlign="center" direction="vertical">
          <Heading className={s.title} light>
            Something went wrong
          </Heading>
          <Heading className={s.subtitle} light>
            We couldn’t load this page due to a problem on our end.
            <br />
            Please refresh to try again
          </Heading>
        </Box>
        <Box marginTop="SP6" gap="SP2" direction="vertical" align="center">
          <Button dataHook={dataHooks.mainButton()} onClick={handleRefreshButtonClick}>
            Refresh
          </Button>
          <TextButton
            skin="light"
            dataHook={dataHooks.secondButton()}
            onClick={handleGoToDashboardButtonClick}
            underline="always"
          >
            Continue to dashboard
          </TextButton>
        </Box>
      </Box>
    </HeadlessBackground>
  )
}
